import useSWR from 'swr';
import type { SwrReturnType } from '~/models/Api';
import type { Staff } from '~/models/Staff';
import { generatePath } from '~/utils/generatePath';

export const useStaffs = (): SwrReturnType<Staff[]> => {
  const { data, mutate, error, isLoading } = useSWR<Staff[]>(
    generatePath('/staffs')
  );
  return {
    data: data ?? null,
    mutate,
    isLoading,
    error
  };
};

export const useEnabledStaffs = (): SwrReturnType<Staff[]> => {
  const { data, mutate, error, isLoading } = useSWR<Staff[]>(
    generatePath('/staffs')
  );
  return {
    data: data ? data.filter((staff) => staff.enabled) : null,
    mutate,
    isLoading,
    error
  };
};

export const useStaff = (id: number): SwrReturnType<Staff> => {
  const { data, mutate, error, isLoading } = useSWR<Staff>(
    generatePath('/staffs/:id', { id })
  );
  return {
    data: data ?? null,
    mutate,
    isLoading,
    error
  };
};
